export function transformNumToString(num: number | string) {
  if (typeof num === 'string') {
    return num.replace('.', ',');
  }

  return num.toString().replace('.', ',');
}
